module.exports = __webpack_public_path__ + "img/Medical research-rafiki.7f5bc754.svg";